import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { miscSessionCreatePost } from '../../../../api-client/api-svcpp-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const postMiscSessionCreate = createAsyncThunk(
    'postMiscSessionCreate/Get',
    async (body, { rejectWithValue }) => {
        try {
            const response = await miscSessionCreatePost(body);
            const data = response.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'GET_MISC_SESSION_FETCH_FAILURE',
                error: err,
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

export const postMiscSessionCreateSlice = createSlice({
    name: 'postMiscSessionCreate',
    initialState,
    extraReducers: {
        [postMiscSessionCreate.pending]: (state) => {
            state.loading = true;
        },
        [postMiscSessionCreate.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
        },
        [postMiscSessionCreate.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const postMiscSessionCreateSelector = (state) => state.postMiscSessionCreate;
export const postMiscSessionCreateReducer = postMiscSessionCreateSlice.reducer;
